import { AvField, AvForm } from 'availity-reactstrap-validation'
import { useEffect, useState } from 'react'
import { Button, ListGroup, ListGroupItem } from 'reactstrap'
import { tidyName } from '../../../helper'
import CMSRichText from '../richText'
import Switch from 'react-switch'
import { updatePublicPageCMS } from '../../../Helper/publicPageHelper'
import { primary_color } from '../../../Helper/uiHelper'
import { request } from '../../../Redux/Sagas/requests/api'

const getTitle = (name) => {
  switch (name) {
    case 'heading':
      return 'Main Heading'
    case 'heading_two':
      return 'FAQ Heading'
    case 'heading_three':
      return 'FAQ Heading > after query selected'
    case 'heading_four':
      return 'Did this resolve your query'
    case 'heading_five':
      return 'Is this query booking related'
    case 'heading_six':
      return 'Message us'
    case 'heading_seven':
      return 'Success message'
    case 'sub_heading':
      return 'Non Booking query message'
    default:
      return tidyName(name)
  }
}

const CMSfaq = ({ data, widget_uuid, toggleModal, isRaiseTicket, showOnlyFields, hideManageQuestion }) => {
  const [formData, setFormData] = useState()
  const [faqType, setFAQType] = useState()
  const [additionInfo, setAdditionalInfo] = useState({})

  useEffect(() => {
    const newState = data
      ?.map((item) => {
        let type = 'rich_text'

        if (item?.component_name === 'additional_setting' || item?.component_name === 'form') {
          return
        }
        return {
          component_name: item?.component_name,
          value: item?.value,
          uuid: item?.uuid,
          type,
          title: !isRaiseTicket ? tidyName(item?.component_name) : getTitle(item?.component_name),
        }
      })
      ?.filter((item) => item)
    const info = data?.find((item) => item.component_name === 'additional_setting')
    if (info?.value) {
      setAdditionalInfo(JSON.parse(info?.value))
    }

    setFormData(newState)
    request('raise-ticket/get-faq-type', 'POST').then((res) => {
      if (res?.data) {
        setFAQType(res?.data)
      }
    })
  }, [])

  const onChangeValue = (uuid, v) => {
    setFormData((od) => {
      let newData = od?.map((oldData) => {
        if (oldData?.uuid !== uuid) {
          return oldData
        } else {
          return {
            ...oldData,
            value: v,
          }
        }
      })
      return newData
    })
  }

  const onChangeFaqToggle = (id) => {
    let currentData = additionInfo?.faq_type ? [...additionInfo?.faq_type] : []
    if (currentData?.includes(id)) {
      const i = currentData?.indexOf(id)
      currentData.splice(i, 1)
    } else {
      currentData?.push(id)
    }
    setAdditionalInfo({
      ...additionInfo,
      faq_type: currentData,
    })
  }

  const onSubmit = () => {
    let payloadData = formData
    const info = data?.find((item) => item.component_name === 'additional_setting')
    info['value'] = JSON.stringify(additionInfo)
    payloadData.push(info)
    let payload = {
      uuid: widget_uuid,
      data: payloadData,
    }
    updatePublicPageCMS(payload, toggleModal)
  }


  return (
    <div>
      <div className='d-flex justify-conent-between'>
        <div className='font-weight-bold'>Edit Content</div>
      </div>
      <hr></hr>
      <AvForm>
        <ListGroup>
          <div className='p-1 mt-2 mb-2'>
            <ListGroupItem id={'card_cms_edit'} className='editCMSMainTitle font-weight-bold'>
              Edit Text
            </ListGroupItem>
            <div className='mt-3'>
              {formData?.map((item) => {
                if (showOnlyFields?.length > 0 && !showOnlyFields?.includes(item?.component_name)) return
                if (item?.type === 'rich_text') {
                  return (
                    <CMSRichText
                      data={{ field_id: item?.uuid }}
                      id={item?.uuid}
                      title={item?.title}
                      value={item?.value}
                      onChange={(v) => {
                        onChangeValue(item?.uuid, v)
                        // setFormData((val) => ({
                        //   ...val,
                        //   heading: v,
                        // }))
                      }}
                    />
                  )
                }
              })}
            </div>
          </div>
          {!hideManageQuestion && (
            <div className='p-1 mt-2 mb-2'>
              <ListGroupItem className='editCMSMainTitle font-weight-bold'>Manage Question</ListGroupItem>
              {!isRaiseTicket && (
                <div className='mt-4 '>
                  <div className='d-flex mb-3'>
                    {' '}
                    <Switch
                      height={22}
                      width={45}
                      checked={additionInfo?.query_type_as_heading}
                      onChange={() => {
                        setAdditionalInfo({
                          ...additionInfo,
                          query_type_as_heading: !additionInfo?.query_type_as_heading,
                
                        })
                      }}
                      checkedIcon={null}
                      uncheckedIcon={null}
                      onColor={primary_color}
                    />
                    <div className='ml-2'>Query Type as heading</div>
                  </div>
                  <div className='d-flex mb-2'>
                    {' '}
                    <Switch
                      height={22}
                      width={45}
                      checked={additionInfo?.query_as_heading}
                      onChange={() => {
                        setAdditionalInfo({
                          ...additionInfo,
                          query_as_heading: !additionInfo?.query_as_heading,
                        })
                      }}
                      checkedIcon={null}
                      uncheckedIcon={null}
                      onColor={primary_color}
                    />
                    <div className='ml-2'>Query as heading</div>
                  </div>
                </div>
              )}

              <div className='mt-4'>
                <div className='text-muted'>FAQ type</div>
                <div className='mt-4'>
                  {faqType?.map((item) => {
                    return (
                      <div style={{ border: `1px solid #00000011` }} className='py-3 px-2 d-flex align-items-center'>
                        <div className='d-flex'>
                          {' '}
                          <Switch
                            height={22}
                            width={45}
                            checked={additionInfo?.faq_type?.includes(item?.id)}
                            onChange={() => {
                              onChangeFaqToggle(item?.id)
                            }}
                            checkedIcon={null}
                            uncheckedIcon={null}
                            onColor={primary_color}
                          />
                          <div className='ml-2'>{item?.name}</div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div className='mt-4'>
                <AvField
                  label='pagination'
                  name='pagination'
                  placeholder='No of row'
                  value={additionInfo?.pagination}
                  onChange={(e) => {
                    setAdditionalInfo({
                      ...additionInfo,
                      pagination: e.target.value,
                    })
                  }}></AvField>
              </div>
            </div>
          )}
        </ListGroup>
      </AvForm>
      <div className='d-flex justify-content-end mt-4'>
        <Button
          outline
          color='danger'
          className='mr-2'
          onClick={(e) => {
            e.stopPropagation()
            toggleModal()
          }}>
          Discard
        </Button>
        <Button color='info' onClick={onSubmit}>
          Save
        </Button>
      </div>
    </div>
  )
}

export default CMSfaq
